<section class="manufacturer-check-page">
  <div class="custom-login background-image"></div>
  @if (orderToProcess) {
    <div class="manufacturer-check-shell">
      <div class="manufacturer-check-card">
        <h1 class="manufacturer-check-title">
          {{ pageTitle }}
        </h1>

        <app-check-order-selector
          [label]="'Ordine completato!'"
          [value]="selectorValue"
          [tone]="'success'"
        ></app-check-order-selector>
        @if (orderToProcess.ddt_url != "" && orderToProcess.ddt_url != null) {
          <p class="manufacturer-check-ddt-info">
            DDT selezionato: "
            <a href="{{ orderToProcess?.ddt_url }}" target="_blank">
              {{ orderToProcess.ddt_file }}
            </a>
            "
          </p>
        }
        @if (isViewingArticleLots) {
          <app-check-order-lots
            [lots]="selectedArticleLots"
            [productToWorkOn]="productToWorkOn"
            [batchToAddFileTo]="newBatchToUpload"
            [completed]="orderCompleted"
          ></app-check-order-lots>
        } @else {
          <app-check-order-articles
            [products]="productsFromOrder"
            [selectedCode]="selectedArticleCode"
            [processedCodes]="visibleProcessedArticleCodes"
            [completed]="orderCompleted"
            [orderId]="orderToProcess?.supplier_certificate_id"
            actionLabel="ELABORA LOTTO"
            (articleSelected)="selectArticle($event)"
            (articleAction)="prepareAnotherArticle($event)"
          ></app-check-order-articles>
        }

        <div class="manufacturer-actions">
          <button
            type="button"
            class="manufacturer-action manufacturer-action--back"
            (click)="back()"
          >
            <i class="bx bx-left-arrow-circle"></i>
            <span>INDIETRO</span>
          </button>
        </div>
      </div>
      <div class="footer">©{{ currentYear }} | Connecta</div>
    </div>
  } @else {
    <span style="z-index: 1">loading...</span>
  }
</section>
